'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  position: absolute;\n  top: 3px;\n  bottom: 0;\n  left: 4px;\n  right: 0;\n\n  & > g > g > path {\n    fill: ', ';\n  }\n'], ['\n  width: ', ';\n  position: absolute;\n  top: 3px;\n  bottom: 0;\n  left: 4px;\n  right: 0;\n\n  & > g > g > path {\n    fill: ', ';\n  }\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledSVG = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width ? props.width : '1.5rem';
}, function (props) {
  return props.theme.color_blue;
});
var BackSVG = function BackSVG(props) {
  return _react2.default.createElement(StyledSVG, Object.assign({
    viewBox: '0 0 632 667'
  }, props), _react2.default.createElement('g', null, _react2.default.createElement('g', {
    id: 'reply'
  }, _react2.default.createElement('path', {
    d: 'M178.5,140.25v-102L0,216.75l178.5,178.5V290.7c127.5,0,\r 216.75,40.8,280.5,130.05C433.5,293.25,357,165.75,178.5,140.25z'
  }))));
};
exports.default = BackSVG;